import { useState } from "react";
import restApiService from "../restApiService";
import { useDispatch } from "react-redux";
import { toast } from "../../store/toastSlice";
import { AlertType } from "../../shared/constants/enums";

function useDelete() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const deleteService = async (url: string, data?: any, message = "") => {
    setLoading(true);
    try {
      const response = await restApiService.delete(url, data);

      setLoading(false);
      dispatch(
        toast({
          isOpen: true,
          message: message || "Deleted Successfully",
          type: AlertType.SUCCESS,
        })
      );
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        (error.code.includes("ERR_NETWORK")
          ? "Connection timed out. Please try again later."
          : "An unexpected error has occurred");
      setLoading(false);
      setError(errorMessage);
      dispatch(
        toast({
          isOpen: true,
          message: errorMessage,
          type: AlertType.ERROR,
        })
      );
    }
  };
  return { loading, error, deleteService };
}

export default useDelete;
